import api from "../service/historico.service";
import * as types from "./historico.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put } from "redux-saga/effects";
import historicoActions from "./historico.actions";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.ADD_SAGA_HISTORICO, addSagaHistorico);
  yield takeEvery(types.DELETE_SAGA_HISTORICO, deleteSagaHistorico);
}

function* addSagaHistorico(action) {
  const { payload } = action;
  yield put(historicoActions.addHistorico(payload));
  yield put(formActions.gridReload());
}

function* deleteSagaHistorico(action) {
  const { payload } = action;
  yield put(historicoActions.deleteHistorico(payload));
  yield put(formActions.gridReload());
}

